/* eslint-disable linebreak-style */
import { combineReducers } from 'redux'
import auth from './auth'
import user from './user'
import userContest from './userContest'
import cms from './cms'

export default combineReducers({
  auth,
  user,
  userContest,
  cms
})
